import moment from 'moment'
import { hexToRgb } from '../../../common/helper'
import { headColor } from '../../dashBoard/businessAnalysis'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import { withPxWidths } from '../../../common/mathHelper'
import autoTable from 'jspdf-autotable'
import { xlCol } from '../../../common/constants'
import { lrDetailPdfFooterForMavenPDF } from '../../AcountingReport/common/AcountingConstants'

export const makeTable = (doc, autoTable, header, body, pdfFontSize, reportname, loginData, showHead = "everyPage", customFunction = false, topMargin = 120, lastColor = true, isStartYValue = false, showColumnBorders = false, options = {}) => {
  const isIncreFontSize = !!options?.isIncreFontSize
  const tableFontSize = pdfFontSize * (options?.isIncreFontSize === 2 ? 22 : isIncreFontSize ? 16 : 14)
  const tableFontStyle = isIncreFontSize ? 'bold' : 'normal'
  const isLargeRowHeight = options?.isLargeRowHeight === true
  const enableTextColor = options?.enableTextColor === true
  const lineColor = options?.lineColor
  const bodyRowHeight = isLargeRowHeight ? 40 : 26
  const lineWidth = showColumnBorders
    ? { top: 0.5, bottom: 0.5, left: 0.5, right: 0.5 }
    : { top: 0.5, bottom: 0.5, left: 0, right: 0 }
  const bodyLineWidth = showColumnBorders
    ? { top: 0.3, bottom: 0.3, left: 0.3, right: 0.3 }
    : { top: 0.3, bottom: 0.3, left: 0, right: 0 }
  const columnStyles = {}
  header.forEach((col, index) => {
    if (col.width) {
      columnStyles[index] = {
        cellWidth: parseInt(col.width),
        overflow: parseInt(col.width) ? 'linebreak' : 'auto',
      }
    }
  })
  return autoTable(doc, {
    startY: isStartYValue ? topMargin : doc.lastAutoTable ? doc.lastAutoTable.finalY + 40 : topMargin,
    margin: { top: 120, left: 30, right: 30, bottom: 30 },
    alternateRowStyles: { fillColor: [255, 255, 255] },
    columns: header,
    theme: 'grid',
    showHead: showHead,
    body: body,
    headStyles: {
      minCellHeight: 36,
      valign: 'middle',
      lineWidth,
      fontStyle: isIncreFontSize ? 'bold' : undefined,
      ...(lineColor ? { lineColor } : {}),
    },
    bodyStyles: {
       minCellHeight: bodyRowHeight,
      valign: 'middle',
      lineWidth: bodyLineWidth,
      fontStyle: tableFontStyle,
      ...(lineColor ? { lineColor } : {}),
    },
    styles: {
      fontSize: tableFontSize,
      cellWidth: 'wrap',
      overflow: 'linebreak',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      valign: 'top',
      minCellHeight: bodyRowHeight,
      ...(lineColor ? { lineColor } : {}),
    },
    columnStyles,
    willDrawCell: (data) => {
      const isLastColumn = data.column.index === data.table.columns.length - 1
      const columnKey = data.column.dataKey
      const cellStyle = data?.row?.raw?.cellStyle?.[columnKey] || {}
      data.cell.styles.valign = 'middle'
      doc.setFontSize(tableFontSize).setFont('Roboto', tableFontStyle)
      const rowType = data.row.raw.dataType
      const hexColor = cellStyle.backgroundColor || headColor[rowType] || headColor.header
      const rgb = hexToRgb(hexColor)
      data.cell.styles.fillColor = rgb
      doc.setFillColor(...rgb)
      doc.setTextColor(0, 0, 0)
      if (enableTextColor && cellStyle.color) {
        const textRgb = hexToRgb(cellStyle.color)
        doc.setTextColor(...textRgb)
      } else if (isLastColumn && lastColor && rowType === 'entry') {
        doc.setTextColor(0, 134, 255)
      }
    },
    didParseCell: (data) => {
      const colDef = data.column.raw
      const colSpanMap = data?.row?.raw?.colSpan || {}
      const columnKey = data.column.dataKey
      const alignMap = data?.row?.raw?.align || {};
      const cellStyle = data?.row?.raw?.cellStyle?.[columnKey] || {}
      if (['string'].includes(colDef.xlCol.dataType)) {
        data.cell.styles.halign = 'left'
      } else if (['quantity', 'number'].includes(colDef.xlCol.dataType) && data.row.raw.dataType !== 'subHeader') {
        data.cell.styles.halign = 'right'
      }
      if (colDef.align) {
        data.cell.styles.halign = colDef.align
      }
      if (cellStyle.backgroundColor) {
        data.cell.styles.fillColor = hexToRgb(cellStyle.backgroundColor)
      }
      if (alignMap.hasOwnProperty(columnKey)) {
        data.cell.styles.halign = alignMap[columnKey];
      }
      if (colSpanMap.hasOwnProperty(columnKey)) {
        data.cell.colSpan = colSpanMap[columnKey]
      }
      if (enableTextColor && cellStyle.color) {
        data.cell.styles.textColor = hexToRgb(cellStyle.color)
      }
    },
    didDrawPage: (data) => {
      if (!customFunction) {
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(pdfFontSize * 20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System | ${reportname}`, 90, 80)

        doc.setTextColor(0, 0, 0)
        doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        doc.setFontSize(16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 30, pageHeight - 5)
        doc.text(
          `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
          doc.internal.pageSize.width / 2 -
          (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
          2 +
          90,
          pageHeight - 5
        )
      } else {
        customFunction(data, doc)
      }
    }
  })
}
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
export const downloadPDF = (payload) => {
  const {
    reportName,
    criteriaHeaders,
    criteriaData,
    tableData,
    visibleColumns,
    loginData,
    showColumnBorders = false,
    hideHeader,
    fitCriteriaToPage = false,
  } = payload
  jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
  jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
  const pdfFontSize = 1
  const orientation = visibleColumns.length > 14 ? 'l' : 'p'
  const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
  const HeaderColumns = (fitCriteriaToPage
    ? withPxWidths(
        criteriaHeaders.map((col) => ({ ...col, weight: col.weight ?? 80 })),
        format[0] - 60
      )
    : criteriaHeaders
  ).map((col) => {
    return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol, ...(col.width ? { width: col.width } : {}) }
  })
  const pdfColumns = withPxWidths(visibleColumns, format[0] - 60).map((col) => {
    return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0, align: col.align }
  })
  const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
  var totalPagesExp = '{total_pages_count_string}'
  doc.setProperties({
    title: `${reportName}.pdf`,
    subject: `${reportName}`,
    author: 'Maven Tech Labs Pvt. Ltd.',
    keywords: 'maven tech, Cargo system, Receive',
    creator: 'MTLPL',
  })
  const customFunction = (data, doc) => {
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
  }
  const customFunction2 = (data, doc) => {
    lrDetailPdfFooterForMavenPDF(data, loginData, totalPagesExp)
  }
  makeTable(doc, autoTable, HeaderColumns, criteriaData, pdfFontSize, reportName, loginData, 'everyPage', customFunction, 120, false)
  makeTable(doc, autoTable, pdfColumns, tableData, pdfFontSize, reportName, loginData, hideHeader ? 'never' : 'everyPage', customFunction2, 120, true, false, showColumnBorders)
  
  setTimeout(() => {
    const pageCount = doc.internal.getNumberOfPages()

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)

      const pageHeight =
        doc.internal.pageSize.height || doc.internal.pageSize.getHeight()
      const pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth()

      doc.setFont('helvetica', 'normal')
      doc.setFontSize(16)

      doc.text(
        `Page : ${i} of ${pageCount}`,
        pageWidth - 40,
        pageHeight - 8,
        { align: 'right' }
      )
    }

    doc.save(`${reportName} ${currentDateTime}.pdf`)
  }, 0)  
}

export const downloadMultiTablePDF = (payload) => {
  const {
    reportName,
    criteriaHeaders,
    criteriaData,
    tables,  // array of { tableData, visibleColumns, hideHeader }
    loginData,
    showColumnBorders = false,
    fitCriteriaToPage = false,
  } = payload

  jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
  jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

  const pdfFontSize = 1
  const maxVisibleColumns = Math.max(...tables.map((table) => table?.visibleColumns?.length || 0))
  const orientation = maxVisibleColumns > 14 ? 'l' : 'p'
  const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
  const HeaderColumns = (fitCriteriaToPage
    ? withPxWidths(
        criteriaHeaders.map((col) => ({ ...col, weight: col.weight ?? 80 })),
        format[0] - 60
      )
    : criteriaHeaders
  ).map((col) => ({
    header: col.header,
    dataKey: col.field,
    xlCol: col.xlCol || xlCol,
    ...(col.width ? { width: col.width } : {}),
  }))

  const doc = new jsPDF({ orientation, format, unit: 'px', compress: true })
  const totalPagesExp = '{total_pages_count_string}'

  doc.setProperties({
    title: `${reportName}.pdf`,
    subject: `${reportName}`,
    author: 'Maven Tech Labs Pvt. Ltd.',
    keywords: 'maven tech, Cargo system',
    creator: 'MTLPL',
  })

  const customFunction = (data, doc) => {
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
  }

  const customFunction2 = (data, doc) => {
    lrDetailPdfFooterForMavenPDF(data, loginData, totalPagesExp)
  }

  // Criteria table
  makeTable(doc, autoTable, HeaderColumns, criteriaData, pdfFontSize, reportName, loginData, 'everyPage', customFunction, 120, false)

  // Each data table
  tables.forEach((table, index) => {
    const pdfColumns = withPxWidths(table.visibleColumns, format[0] - 60).map((col) => ({
      header: col.exportHead,
      dataKey: col.field,
      xlCol: col.xlCol,
      width: col.width || 0,
    }))

    let startY = 120    
    if (table.reportName) {
      autoTable(doc, {
        margin: { left: 30, right: 30, bottom: 0 },
        startY: doc.lastAutoTable.finalY + 14,
        theme: 'plain',
        head: [],
        body: [[table.reportName]],
        bodyStyles: {
          minCellHeight: 35,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'bold',
          fontSize: 16,
          halign: 'left',

        },
      })
      startY = doc.lastAutoTable.finalY;
    } else {
      startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 120
    }

    if (table.summaryFields?.length) {
      const sectionField = table.summaryFields.find((item) => item.isSection)
      const detailSummaryFields = table.summaryFields.filter((item) => !item.isSection)
      const leftSummaryFields = detailSummaryFields.filter((_, index) => index % 2 === 0)
      const rightSummaryFields = detailSummaryFields.filter((_, index) => index % 2 !== 0)
      const summaryBody = []

      if (sectionField) {
        summaryBody.push([sectionField.value || '', ''])
      }

      for (let index = 0; index < Math.max(leftSummaryFields.length, rightSummaryFields.length); index += 1) {
        const leftField = leftSummaryFields[index]
        const rightField = rightSummaryFields[index]
        summaryBody.push([
          `${leftField?.label || ''} : ${leftField?.value || ''}`,
          `${rightField?.label || ''} : ${rightField?.value || ''}`,
        ])
      }

      autoTable(doc, {
        margin: { left: 30, right: 30, bottom: 0 },
        startY: startY + 4,
        theme: 'plain',
        body: summaryBody,
        styles: {
          minCellHeight: 20,
          font: 'Roboto',
          fontStyle: 'bold',
          fontSize: 12,
          cellPadding: 0,
          textColor: [68, 68, 68],
        },
        columnStyles: {
          0: { halign: 'left', cellWidth: 'wrap' },
          1: { halign: 'right', cellWidth: 'wrap' },
        },
        didParseCell: (data) => {
          if (sectionField && data.row.index === 0) {
            if (data.column.index === 0) {
              data.cell.styles.fontStyle = 'bold'
            } else {
              data.cell.text = ['']
            }
          }
        },
      })
      startY = doc.lastAutoTable.finalY + 6
    }

    makeTable(
      doc,
      autoTable,
      pdfColumns,
      table.tableData,
      pdfFontSize,
      table.reportName || reportName,
      loginData,
      table.hideHeader ? 'never' : 'everyPage',
      customFunction2,
      startY, true, true,
      showColumnBorders,
      table.options || {} 
    )
  })

  setTimeout(() => {
    const pageCount = doc.internal.getNumberOfPages()

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)

      const pageHeight =
        doc.internal.pageSize.height || doc.internal.pageSize.getHeight()
      const pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth()

      doc.setFont('helvetica', 'normal')
      doc.setFontSize(16)

      doc.text(
        `Page : ${i} of ${pageCount}`,
        pageWidth - 40,
        pageHeight - 8,
        { align: 'right' }
      )
    }

    doc.save(`${reportName} ${currentDateTime}.pdf`)
  }, 0)  
}